import { useLayoutEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { applyAppFondo, applyAppFuente } from '../utils/appFondo';

/** Aplica el fondo cuando el contenedor principal ya está montado. */
const AppFondoApplicator = () => {
  const { user } = useAuth();

  useLayoutEffect(() => {
    const opciones = {
      fondoPersonalizado: user?.fondoPersonalizado,
      fondoOpacidad: user?.fondoOpacidad,
      updatedAt: user?.updatedAt
    };

    applyAppFuente(user?.fuenteInterfaz);
    applyAppFondo(opciones);

    // En una navegación muy temprana puede intervenir el montaje del layout.
    // Un único reintento evita observar toda la aplicación o generar ciclos.
    const frameId = window.requestAnimationFrame(() => applyAppFondo(opciones));
    return () => window.cancelAnimationFrame(frameId);
  }, [user?.fondoPersonalizado, user?.fondoOpacidad, user?.updatedAt, user?.fuenteInterfaz]);

  return null;
};

export default AppFondoApplicator;
